export const isNatural = (value) => {
  if (!value || !Number.isInteger(parseInt(value, 10)) || parseInt(value, 10) < 0) {
    return false
  }
  return true
}
